var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx:window-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2422 6.04946L10.8729 4.68015L8.65234 6.90068L6.43181 4.68015L5.0625 6.04946L7.28303 8.26999L5.0625 10.4905L6.43181 11.8598L8.65234 9.6393L10.8729 11.8598L12.2422 10.4905L10.0217 8.26999L12.2422 6.04946Z",
    fill: "#991B1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxClose);
export default __webpack_public_path__ + "static/media/bx-close.9372bf1d33b1a05a3363f1955dbce55e.svg";
export { ForwardRef as ReactComponent };